<template>
  <div class="universal-order-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'UniversalOrderIndex'
}
</script>

<style lang="less" scoped>
.universal-order-container {
  padding: 20px;
  height: 100%;
}
</style>
